---
title: Tech Term Glossary: Wrong Answers Only
date: 2020-06-08T20:32:28-07:00
draft: false
---

- **React:** PHP, but with javascript
- **Webpack:** Devops work, but with frontend pay 
- **Redux:** global variables dressed up to feel less embarrassing when using
- **iOS:** webviews that cost more
- **Rails:** web framework built so DHH could flex his ability to code in a language no one cared about
- **Elixir:** Erlang, but for Rails devs that don't want to earn a new language
- **C#:** white paper on how to steal from Sun Microsystems, put out by Microsoft to shame Google’s inability to do the same
- **Scala:** when you want a functional language, but are stuck with the JVM
- **Kotlin:** when you wanted Swift, but are stuck as an Android dev
- **Machine learning:** spreadsheets that you hide in code
- **Data Scientist:** statisticians who figured out that a change in title can double your pay
- **Kubernetes:** Trusting Google’s advice, even if you are not sure what it actually means
- **AWS:** Paying more for servers so that you can pretend you're ready for hidden scaling events
- **Cloud Functions:** easy method to trade money for not having to deal with sysadmin work
- **Jira ticket:** placeholder for incomplete ideas
- **Confluence:** where to hide stuff that was really important one time, and forgotten soon after
- **Agile:** waterfall, but with hidden steps
- **Refactor:** small changes to a code base that objectively improve it over time
- **Standup:** a short meeting where everybody shares what they're working on, but no one listens 
- **Retro:** a meeting where managers listen to developers, then feed them false hope of positive change
- **Slack:** black hole of important conversations and decisions that you kind of remember, but can never find
